import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import './NavBar.css';

const NavBar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isRendered, setIsRendered] = useState(false); // Ensures re-render
    const [username, setUsername] = useState(null);

    useEffect(() => {
        setIsRendered(true); // Force re-render on mount
        const storedUsername = localStorage.getItem('unique_username');
        setUsername(storedUsername);
    }, []);

    useEffect(() => {
        const handleStorageChange = () => {
            setUsername(localStorage.getItem('unique_username'));
        };
        
        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <motion.nav
            initial={{ opacity: 0 }}
            animate={{ opacity: isRendered ? 1 : 0 }}
            transition={{ duration: 0.5 }}
            className="navbar"
        >   
            <nav className="navbar">
                <div className="logo">
                    <Link to="/" onClick={closeMenu}>Unpager</Link>
                </div>
                <div className={`nav-links ${isOpen ? "open" : ""}`}>
                    <Link to="/" onClick={closeMenu}>Home</Link>
                    <Link to="/upload" onClick={closeMenu}>Upload</Link>
                    <Link to="/profile" onClick={closeMenu}>Profile</Link>
                    <Link to="/login" onClick={closeMenu}>
                        {username ? `Welcome, ${username}` : "Login"}
                    </Link>
                    <Link to="/register" onClick={closeMenu}>Register</Link>
                </div>
                
                {/* Animated Hamburger Menu */}
                <div className={`hamburger ${isOpen ? "active" : ""}`} onClick={toggleMenu}>
                    <div className="bar"></div>
                    <div className="bar"></div>
                    <div className="bar"></div>
                </div>
            </nav>
        </motion.nav>
    );
};

export default NavBar;
